const state = () => ({
    //매장제품리스트 사이드 팝업
    isSidePrdtListPopup: false
})

const getters = {
    getIsSidePopup: state => state.isSidePrdtListPopup
}


const actions = {
    
    setIsSidePopup({ commit }, isSidePrdtListPopup) {
        commit('SET_IS_SIDE_PRDT_LIST_TOGGLE', isSidePrdtListPopup)
    }
}


const mutations = { 
    SET_IS_SIDE_PRDT_LIST_TOGGLE(state, payload){
        state.isSidePrdtListPopup = payload
    }
}


export default {
    namespaced: true,
	state,
	getters,
	actions,
	mutations,
}


